exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body {\n  font-family: Lato, Roboto, Noto, Helvetica, Tahoma, Arial, \"Microsoft YaHei New\", \"Microsoft Yahei\", \"Noto Sans CJK SC\", \"Noto Sans CJK\", \"\\5FAE\\8F6F\\96C5\\9ED1\", \"\\5B8B\\4F53\", SimSun, STXihei, \"\\534E\\6587\\7EC6\\9ED1\", \"PingFang SC\", sans-serif;\n}\n.serif {\n  font-family: Baskerville, \"Lucida Bright\", \"Times New Roman\", \"Times\";\n}\n.resetButton {\n  border: none;\n  background-color: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/catalogo/global.less
// module id = 1356
// module chunks = 0